import { getType } from "typesafe-actions";

import * as OrderActions from "../actions";
import type { ICommissionsState, OrderAction } from "../types";

const initialCommissionsState: ICommissionsState = {
  isFetching: false,
  hasError: false,
  commissionsList: []
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
export default function commissionsReducer(state: ICommissionsState = initialCommissionsState, action: OrderAction) {
  switch (action.type) {
    case getType(OrderActions.fetchCommissionsStart):
      return { ...state, isFetching: true, hasError: false };

    case getType(OrderActions.fetchCommissionsFail):
      return { ...state, isFetching: false, hasError: true };

    case getType(OrderActions.fetchCommissionsSuccess):
      return { ...state, isFetching: false, commissionsList: action.payload };

    default:
      return state;
  }
}
